module.exports = __webpack_public_path__ + "static/media/s3.0dedca9b.png";